import type { WidgetProps } from './registry';
import { decodeWidgetData } from './decode-widget-data';

type Source = { sourceId: string; kind?: string; lastRunAt?: string; prospectsFound?: number };

export function SourcesList(props: WidgetProps) {
  const sources = (decodeWidgetData(props.payload).sources ?? []) as Source[];

  if (sources.length === 0) {
    return <p className="text-sm text-foreground-mute">No sources configured.</p>;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
      {sources.map((s) => (
        <div key={s.sourceId} className="rounded border border-border p-3">
          <p className="text-sm font-medium">{s.sourceId}</p>
          {s.kind && <p className="text-[10px] uppercase tracking-wider text-foreground-mute">{s.kind}</p>}
          {(s.lastRunAt || typeof s.prospectsFound === 'number') && (
            <p className="text-xs text-foreground-mute mt-1">
              {s.lastRunAt ? `Last run: ${s.lastRunAt}` : ''}
              {typeof s.prospectsFound === 'number' ? ` · ${s.prospectsFound} found` : ''}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}
